export const mutations = {
  setNameError(state, nameError = null) {
    state.nameErrors = nameError;
  },
  setEndpointList(state, endpointList) {
    state.endpointList = endpointList;
  },
  setIsSavingDataset(state, isDisable) {
    state.isSavingDataset = isDisable;
  }
};
